import { VisuallyHidden } from '@s-group/design-system-components/VisuallyHidden/VisuallyHidden'
import { BodyText } from '@ui-components/typography/Typography'
import { styled } from 'styled-components'

import { Colors } from '../../global/colors'
import { splitStringInHalf } from '../../utilities/helpers'

const RIGHT_TO_LEFT_THRESHOLD = 3

const TruncatedSpan = styled.span<{ $isLink: boolean; $isValid: boolean; $isLongText: boolean }>`
  pointer-events: auto;
  &:after,
  &:before {
    display: inline-block;
    max-width: 50%;
    overflow: hidden;
    white-space: pre;
    box-shadow: ${(props) => (props.$isLink ? `inset 0 -2px 0 currentColor` : `unset`)};
    cursor: ${(props) => (props.$isLink ? 'pointer' : 'default')};
    color: ${(props) => (props.$isValid ? `${Colors.TextStrongPrimary}` : `${Colors.TextStrongNeutral}`)};
  }

  &:before {
    content: attr(data-content-start);
    text-overflow: clip;
  }

  &:after {
    content: attr(data-content-end);
    text-overflow: ellipsis;
    direction: ${(props) => (props.$isLongText ? 'rtl' : 'unset')};
  }
`

export const TruncatedInMiddleSpan = ({
  text,
  isValid,
  isLink = false,
  isLinkAriaLabel,
}: {
  text: string
  isValid: boolean
  isLink?: boolean
  isLinkAriaLabel?: string
}) => {
  const splitResult = splitStringInHalf(text)
  return (
    <BodyText tagName={'div'}>
      <TruncatedSpan
        data-content-start={splitResult.firstHalf}
        data-content-end={splitResult.secondHalf}
        title={text}
        aria-hidden={true}
        $isLink={isLink}
        $isValid={isValid}
        $isLongText={splitResult.firstHalf.length > RIGHT_TO_LEFT_THRESHOLD}
      />
      <VisuallyHidden>{isLinkAriaLabel || text}</VisuallyHidden>
    </BodyText>
  )
}
